import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { checkAuth } from "./services/api";
import { AuthForm, AuthFormType } from "./components/Auth/AuthForm";
import { VerifyPrompt } from "./components/Auth/VerifyPrompt";
import { SetPasswordForm } from "./components/Auth/SetPasswordForm";
import { ManageSubscription } from "./components/Subscription/ManageSubscription";
import { Logout } from "./components/Auth/Logout";
import { Cloud } from "./components/Cloud";
import { Layout } from "./components/Layout";

function App(): JSX.Element {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<{ id: string; email: string } | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const verifyAuth = () => {
        checkAuth().then(({ authenticated, user }) => {
            console.log("checkAuth authenticated", authenticated, user);
            setIsAuthenticated(authenticated);
            setUser(user);
            setIsLoading(false);
        }).catch((error) => {
            console.log("checkAuth error", error);
            setIsAuthenticated(false);
            setIsLoading(false);
        });
    };
    verifyAuth()
  }, []);

  // Show loading screen while checking authentication
  if (isLoading) {
    return (
      <div className="App">
        <Layout width="400px">
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="text-muted">Checking authentication...</div>
          </div>
        </Layout>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              <AuthForm
                isLogin={true}
                formType={AuthFormType.LOGIN}
                initialMsg={null}
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
                setUser={setUser}
              />
            }
          />
          <Route
            path="/signup"
            element={
              <AuthForm
                isLogin={false}
                formType={AuthFormType.SIGNUP}
                initialMsg={null}
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
                setUser={setUser}
              />
            }
          />
          <Route
            path="/forgot-password"
            element={
              <AuthForm
                isLogin={false}
                formType={AuthFormType.FORGOT_PASSWORD}
                initialMsg={null}
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
                setUser={setUser}
              />
            }
          />
          <Route
            path="/reset-password-sent"
            element={
              <VerifyPrompt
                title="Check your email"
                message="Click on the link to reset your password."
                wrongEmailHref="/forgot-password"
              />
            }
          />
          <Route path="/" element={<Navigate to="/signup" />} />
          <Route path="/verify-prompt" element={<VerifyPrompt />} />
          <Route
            path="/verify-email"
            element={
              <SetPasswordForm
                isReset={false}
                setIsAuthenticated={setIsAuthenticated}
                setUser={setUser}
              />
            }
          />
          <Route
            path="/reset-password"
            element={
              <SetPasswordForm
                isReset={true}
                setIsAuthenticated={setIsAuthenticated}
                setUser={setUser}
              />
            }
          />
          <Route
            path="/subscription"
            element={
              <ManageSubscription
                isAuthenticated={isAuthenticated}
                user={user}
              />
            }
          />
          <Route
            path="/cloud"
            element={
              <Cloud
                isAuthenticated={isAuthenticated}
                user={user}
              />
            }
          />
          <Route path="/logout" element={<Logout />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
